import React from 'react';
import { LocalizationContext, defaultTag, defaultSuffix, } from './context';
export var LocalizationProvider = function (_a) {
    var children = _a.children, locale = _a.locale, translations = _a.translations, _b = _a.tag, tag = _b === void 0 ? defaultTag : _b, _c = _a.suffix, suffix = _c === void 0 ? defaultSuffix : _c;
    return (React.createElement(LocalizationContext.Provider, { value: {
            locale: locale,
            translations: translations,
            tag: tag,
            suffix: suffix,
        } }, children));
};
//# sourceMappingURL=provider.js.map